/** Copyright ©2026 Devexperts LLC.
All rights reserved. Any unauthorized use will constitute an infringement of copyright.
In case of any questions regarding types of use, please contact legal@devexperts.com.
This notice must remain intact.
**/
export function mulberry32(a){return()=>{let b=a+=0x6d2b79f5;return b=Math['imul'](b^b>>>0xf,b|0x1),b^=b+Math['imul'](b^b>>>0x7,b|0x3d),((b^b>>>0xe)>>>0x0)/0x100000000;};}